import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#F2EFEB] py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        {/* Section header */}
        <div className="max-w-3xl reveal mb-16 sm:mb-24">
          <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C6658] mb-6">
            05 / What we do
          </p>
          <h2 className="font-[Outfit] font-extralight text-[#2D332B] text-[36px] sm:text-[56px] leading-[1.02] tracking-[-0.015em]">
            Three ways
            <br />
            <span className="italic text-[#8A9A86]">we work together.</span>
          </h2>
        </div>

        {/* Alternating cards */}
        <div className="space-y-20 sm:space-y-28">
          {SERVICES.map((s, i) => {
            const imageFirst = i % 2 === 0;
            return (
              <article
                key={s.id}
                data-testid={`service-${s.id}`}
                className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center"
              >
                {/* Image */}
                <div
                  className={`lg:col-span-7 relative aspect-[4/3] overflow-hidden rounded-sm bg-[#F9F8F6] ${
                    imageFirst ? "lg:order-1" : "lg:order-2"
                  }`}
                >
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div
                  className={`lg:col-span-5 ${
                    imageFirst ? "lg:order-2" : "lg:order-1"
                  }`}
                >
                  <p className="text-[11px] tracking-[0.35em] uppercase text-[#5C6658] mb-4">
                    {s.persona}
                  </p>
                  <h3
                    data-testid={`service-title-${s.id}`}
                    className="font-[Outfit] font-light text-[#2D332B] text-[30px] sm:text-[42px] leading-[1.05] tracking-[-0.01em]"
                  >
                    {s.title}
                  </h3>
                  <p className="mt-4 font-[Outfit] italic font-light text-[18px] sm:text-[20px] text-[#8A9A86] leading-[1.3]">
                    {s.tagline}
                  </p>
                  <p className="mt-6 text-[15px] leading-[1.75] text-[#5C6658]">
                    {s.body}
                  </p>

                  {s.bullets && (
                    <ul className="mt-6 space-y-2.5">
                      {s.bullets.map((b, j) => (
                        <li
                          key={j}
                          className="flex items-start gap-3 text-[14px] leading-[1.65] text-[#2D332B]"
                        >
                          <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#8A9A86] shrink-0" />
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  )}

                  <a
                    href={s.cta_href}
                    data-testid={`service-cta-${s.id}`}
                    className="mt-10 inline-flex items-center gap-3 px-6 py-3.5 bg-[#2D332B] text-[#F9F8F6] text-[11px] tracking-[0.3em] uppercase hover:bg-[#8A9A86] transition-colors duration-500 rounded-sm"
                  >
                    {s.cta_label} <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
